'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('multiformats/bases/base64'),
    base64 = _require.base64;

var ciphers = require('../ciphers/aes-gcm');

module.exports = {
  /**
   * Exports the given PrivateKey as a base64 encoded string.
   * The PrivateKey is encrypted via a password derived PBKDF2 key
   * leveraging the aes-gcm cipher algorithm.
   *
   * @param {Uint8Array} privateKey - The PrivateKey protobuf
   * @param {string} password
   * @returns {Promise<string>} A base64 encoded string
   */
  export: function () {
    var _export2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(privateKey, password) {
      var cipher, encryptedKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cipher = ciphers.create();
              _context.next = 3;
              return cipher.encrypt(privateKey, password);

            case 3:
              encryptedKey = _context.sent;
              return _context.abrupt("return", base64.encode(encryptedKey));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function _export(_x, _x2) {
      return _export2.apply(this, arguments);
    }

    return _export;
  }()
};